<template>
	<div class="content-wrapper test">
		<el-form :model="form" ref="form" :inline="true" class="demo-form-inline searchModl" size="small">
			<el-form-item prop="deviceNo">
				<el-select v-model="form.deviceNo" clearable placeholder="车型" class="elInput150">
					<!-- <el-option v-for="item in allList" :key="item.deviceNo" :label="item.stationName"
						:value="item.deviceNo">
					</el-option> -->
				</el-select>
			</el-form-item>
			<el-form-item prop="vin">
				<el-input v-model="form.vin" placeholder="电池类型" clearable class="elInput150" />
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="dateRange" style="width: 240px" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
					type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button class="querybtn" plain @click="">查询</el-button>
				<el-button class="cancelbtn" plain @click="onClearable('form')">清空
				</el-button>
			</el-form-item>
			<el-form-item style="float: right;">

			</el-form-item>
		</el-form>
		<el-divider content-position="left">综合健康度</el-divider>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="contdiv" id="echart1"></div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart2"></div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart3"></div>
			</el-col>
		</el-row>
		<el-divider content-position="left">健康指标</el-divider>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="contdiv" id="echart4"></div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart5"></div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart6"></div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart7"></div>
			</el-col>
		</el-row>
		<el-divider content-position="left">安全指标</el-divider>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="contdiv" id="echart8">
					<ul>
						<li>热失控</li>
						<li><span class="str0"></span>正常</li>
						<li><span class="str1"></span>一级告警</li>
						<li><span class="str2"></span>二级告警</li>
						<li><span class="str3"></span>三级告警</li>
					</ul>
					<table>
						<tr v-for="items in 10">
							<td v-for="item in 10" :class="'str'+tablelist[(items-1)*10+item]">
								{{ (items-1)*10+item}}
							</td>
						</tr>
					</table>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart9">
					<ul>
						<li>冷却系统</li>
						<li><span class="str0"></span>正常</li>
						<li><span class="str1"></span>疑似故障</li>
						<li><span class="str3"></span>故障</li>
					</ul>
					<table>
						<tr v-for="items in 10">
							<td v-for="item in 10" :class="'str'+tablelist2[(items-1)*10+item]">
								{{ (items-1)*10+item}}
							</td>
						</tr>
					</table>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="contdiv" id="echart10">
					<ul>
						<li>气密性</li>
						<li><span class="str0"></span>正常</li>
						<li><span class="str1"></span>疑似故障</li>
						<li><span class="str2"></span>故障</li>
					</ul>
					<table>
						<tr v-for="items in 10">
							<td v-for="item in 10" :class="'str'+tablelist3[(items-1)*10+item]">
								{{ (items-1)*10+item}}
							</td>
						</tr>
					</table>
				</div>
			</el-col>
		</el-row>

	</div>
</template>


<script>
	export default {
		data() {
			return {
				form: {
					deviceNo: '',
					pileCode: '',
					vin: '',
				},
				tablelist: [],
				tablelist2: [],
				tablelist3: [],
				dateRange: ['', ''],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		mounted() {
			let _this = this;
			this.onRadar([90, 80, 90, 90, 70])
			this.onRadar2(90)
			this.onRadar3(100)
			this.onHealthTarget('echart4', 'SOH')
			this.onHealthTarget('echart5', 'SOE')
			this.onHealthTarget('echart6', 'SOT')
			this.onHealthTarget('echart7', '一致性')

			let list = [],
				list2 = [],
				list3 = [];
			for (var i = 0; i <= 100; i++) {
				list.push(_this.random(0, 4));
				list2.push(_this.random(0, 3));
				list3.push(_this.random(0, 3));
			}
			this.tablelist = list;
			this.tablelist2 = list2;
			this.tablelist3 = list3;
		},
		methods: {
			onAllHealth: function(seriesName) {
				let _this = this;
				_this.tempchart = this.$echarts.init(document.getElementById(nameecharts));
				let option = {};
				_this.tempchart.setOption(option, true)
				window.addEventListener("resize", function() {
					_this.tempchart.resize();
				});
			},

			onRadar: function(dataValue) {
				let _this = this;
				_this.radarchart1 = this.$echarts.init(document.getElementById('echart1'));
				var indicator = [{
						name: '电压',
						max: 100,
						num: 1
					},
					{
						name: '内阻',
						max: 100,
						num: 2
					},
					{
						name: '容量',
						max: 100,
						num: 3
					},
					{
						name: '电量',
						max: 100,
						num: 4
					},
					{
						name: '温度',
						max: 100,
						num: 5
					},
				];
				var dataArr = [{
					value: dataValue,
					name: '',
					itemStyle: {
						normal: {
							lineStyle: {
								color: '#17E7FF',
							},
							shadowColor: '#17E7FF',
							shadowBlur: 5,
						},
					}
				}];

				function contains(arr, obj) {
					var i = arr.length;
					while (i--) {
						if (arr[i].name === obj) {
							return i;
						}
					}
					return false;
				}
				var num = 80;
				var option = {
					title: {
						text: '一致性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '10',
						textStyle: {
							color: '#ffffff',
							fontSize: 12,
						}
					},
					color: ['#17E7FF'],
					radar: {
						radius: '70%',
						center: ['50%', '55%'],
						triggerEvent: true,
						name: {
							textStyle: {
								padding: [10, 10, 0, 10],
							},
							formatter: (value) => {
								let i = contains(indicator, value);
								return '{a|' + dataValue[i] + '}\n' + '{b|' + value + '}';
							},
							rich: {
								a: {
									align: 'center',
									color: '#6EFFFD',
									fontWeight: 500,
									fontSize: 16,
								},
								b: {
									align: 'center',
									color: '#FFFFFF',
									fontSize: 10,
								},
								// triggerEvent: true,//开启雷达图的边角名称可点击
							},
						},

						nameGap: 8,
						indicator: indicator,
						splitArea: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: this.$echarts.graphic.RadialGradient(0.5, 0.5, 1, [{
										color: '#15506D0D',
										offset: 0,
									},
									{
										color: '#95E4F0',
										offset: 0.9,
									},
								]),
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(153, 209, 246, 0.5)',
							},
						},
					},
					series: [{
						type: 'radar',
						symbolSize: 8,
						symbol: 'circle',
						data: dataArr,
						areaStyle: {
							color: '#9EDDFF',
							opacity: 0.3,
						},
						lineStyle: {
							color: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							width: 3,
						},
						itemStyle: {
							color: '#fff ',
							borderColor: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							borderWidth: 2,
							opacity: 1,
						}
					}],
				};

				_this.radarchart1.setOption(option, true);
				window.addEventListener("resize", function() {
					_this.radarchart1.resize();
				});

			},
			onRadar2: function(dataArr) {
				let _this = this;
				_this.radarchart2 = this.$echarts.init(document.getElementById('echart2'));

				let angle = 0;
				let maxScore = 100,
					scoresPercentage = dataArr / maxScore;

				var option = {
					title: {
						text: '容量特性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '10',
						textStyle: {
							color: '#ffffff',
							fontSize: 12,
						}
					},

					series: [{
							name: '内部进度条',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '80%',
							z: 1,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: true,
								width: 20,
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 1,
										x2: 0,
										y2: 0,
										colorStops: [{
												offset: 0,
												color: '#3889E3',
											},
											{
												offset: 0.5,
												color: '#3889E3',
											},
											{
												offset: 1,
												color: '#3889E3',
											},
										],
										global: false, // 缺省为 false
									},
								},
							},
							axisLine: {
								lineStyle: {
									color: [
										[1, 'rgba(0, 170, 255, 0.1)']
									],
									width: 20,
								},
							},
							axisLabel: {
								show: true,
								color: 'rgba(240,240,240,0.5)',
								fontSize: 12,
								distance: -10,
								formatter: function(value, index) {

									if (value == 0 || value == 100) {
										return value
									}
								}
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								offsetCenter: [0, '-10%'],
								textStyle: {
									padding: [0, 0, 0, 0],
									fontSize: 24,

									color: 'rgba(240,240,240,1)',
								},
							},
							title: {
								show: true,
								offsetCenter: [0, '15%'],
								textStyle: {
									color: 'rgba(240,240,240,1)',
									fontSize: 12,
									fontFamily: 'PingFangSC',
								},
							},
							data: [{
								name: '分',
								value: dataArr,
							}],
							pointer: {
								show: false,
								length: '75%',
								width: 5,
								itemStyle: {
									color: 'rgba(16,235,227,1)',
								},
							},
						},
						{
							name: '刻度',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '70%',
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: false,
								lineStyle: {
									width: 27,
								},
							},
							//仪表盘轴线
							axisLabel: {
								show: false,
							}, //刻度标签。
							axisTick: {
								show: false,
								splitNumber: 3,
								lineStyle: {
									color: 'rgba(16,235,227,0.2)',
									width: 2,
								},
								length: 2,
								distance: -15
							},
							splitLine: {
								show: false,
								length: 10,
								lineStyle: {
									color: 'rgba(16,235,227,1)',
									width: 2,
								},
								distance: -17
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								//标题
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							name: '最内边线',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '48%',
							z: 999,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: [
										[1, 'rgba(0,255,239,0.2)']
									],
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							name: '最外刻度亮线',
							type: 'gauge',
							radius: '80%',
							center: ['50%', '55%'],
							startAngle: 225 - (270 * dataArr) / 100 + 1,
							endAngle: 225 - (270 * dataArr) / 100 - 30,
							splitNumber: 10,
							axisLine: {
								show: true,
								lineStyle: {
									color: [
										[3 / 100, 'rgba(0,0,0,0)'],
									],
									width: 29,
									shadowColor: 'rgba(16,235,227,1)',
									shadowBlur: 10,
								},
							},
							progress: {
								show: true,
								width: 18,
								itemStyle: {
									color: '#10EBE3',
									shadowColor: 'rgba(16,235,227,1)',
									shadowBlur: 10,
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							pointer: {
								show: false,
							},
							animationDelay: 850,
							animationDuration: 300,
							data: [{
								name: 'title',
								value: 100,
							}, ],
							title: {
								show: false,
							},
						},
						{
							type: 'gauge',
							radius: '90%',
							center: ['50%', '55%'],
							z: 9998,
							min: 0,
							max: 100,
							startAngle: 225,
							endAngle: -45,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 35,
									color: [
										[0.25, '#0F2870'],
										[0.5, '#0F2870'],
										[0.75, '#0F2870'],
										[1, '#0F2870'],
									],
									opacity: 0.1,
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},
							data: [dataArr],
						},
						// 仪表盘值得渐变
						{
							type: 'pie',
							zlevel: 10,
							radius: ['90%', '92%'],
							center: ['50%', '55%'],
							silent: true,
							startAngle: 225,
							endAngle: 45,
							label: {
								show: false,
							},
							labelLine: {
								show: false,
							},
							data: [{
									name: '',
									value: scoresPercentage,
									itemStyle: {
										color: {
											x: 0,
											y: 0,
											x2: 1,
											y2: 0,
											type: 'linear',
											global: false,
											colorStops: [{
													offset: 0,
													color: 'rgba(13,49,118,0.1)',
												},
												{
													offset: 1,
													color: '#00FFEF',
												},
											],
										},
									},
								},
								{
									value: 1.325 - scoresPercentage,
									itemStyle: {
										opacity: 0,
										color: 'rgba(255, 255, 255, 0)',
									},
								},
							],
						},

						// 值得尾巴，那个圆圈
						{
							type: 'pie',
							radius: ['87%', '88%'],
							center: ['50%', '55%'],
							zlevel: 10,
							silent: true,
							startAngle: 225,
							endAngle: 45,
							data: [{
									name: '',
									value: scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(0,0,0,0)',
									},
								},
								{
									name: '',
									value: 0,
									label: {
										position: 'inside',
										backgroundColor: '#00FFF2',
										borderRadius: 12,
										padding: 3, // 可以控制圆的大小
										borderWidth: 3,
										borderColor: 'rgba(0,255,239,0.8)',
									},
								},
								{
									name: '',
									value: 1.325 - scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(255,255,255,0)',
									},
								},
							],
						},

					],
				};


				_this.radarchart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart2.resize();
				});


			},
			onRadar3: function(dataArr) {
				let _this = this;
				_this.radarchart3 = this.$echarts.init(document.getElementById('echart3'));

				let maxScore = 100,
					scoresPercentage = dataArr / maxScore;

				var colorList = [{
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#38B2E3'
					}, {
						offset: 1,
						color: '#38B2E3'
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#32E1D5'
					}, {
						offset: 1,
						color: '#32E1D5'
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#FFC16D'
					}, {
						offset: 1,
						color: '#FFC16D'
					}],
				}];

				var option = {
					title: {
						text: '能量特性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '10',
						textStyle: {
							color: '#ffffff',
							fontSize: 12,
						}
					},

					series: [{
							type: 'gauge',
							splitNumber: 3,
							center: ['50%', '55%'],
							radius: '80%',
							startAngle: 225,
							endAngle: -45,
							min: 0,
							max: 100,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 20,
									color: [
										[0.33, colorList[0]],
										[0.66, colorList[1]],
										[1, colorList[2]],
									],
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: true,
								color: 'rgba(240,240,240,0.5)',
								fontSize: 12,
								distance: -20,
								formatter: function(value, index) {

									if (value == 0 || value == 100) {
										return value
									}
								}
							},
							axisTick: {
								show: false,

							},
							splitLine: {
								show: false,
								length: "28%",
								lineStyle: {
									color: "#fff",
									width: 2,
								},
							},

							detail: {
								offsetCenter: [0, '-10%'],
								textStyle: {
									padding: [0, 0, 0, 0],
									fontSize: 24,

									color: 'rgba(240,240,240,1)',
								},
							},
							title: {
								show: true,
								offsetCenter: [0, '15%'],
								textStyle: {
									color: 'rgba(240,240,240,1)',
									fontSize: 12,
									fontFamily: 'PingFangSC',
								},
							},
							data: [{
								name: '分',
								value: dataArr,
							}],

						},
						{
							name: '最内边线',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '48%',
							z: 999,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: [
										[1, 'rgba(0,255,239,0.2)']
									],
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							type: 'gauge',
							radius: '90%',
							center: ['50%', '55%'],
							z: 9998,
							min: 0,
							max: 100,
							startAngle: 225,
							endAngle: -45,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 35,
									color: [
										[0.25, '#0F2870'],
										[0.5, '#0F2870'],
										[0.75, '#0F2870'],
										[1, '#0F2870'],
									],
									opacity: 0.1,
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},
							data: [dataArr],
						},
						{
							type: 'pie',
							zlevel: 10,
							radius: ['90%', '92%'],
							center: ['50%', '55%'],
							silent: true,
							startAngle: 225,
							endAngle: 45,
							label: {
								show: false,
							},
							labelLine: {
								show: false,
							},
							data: [{
									name: '',
									value: scoresPercentage,
									itemStyle: {
										color: {
											x: 0,
											y: 0,
											x2: 1,
											y2: 0,
											type: 'linear',
											global: false,
											colorStops: [{
													offset: 0,
													color: 'rgba(13,49,118,0.1)',
												},
												{
													offset: 1,
													color: '#00FFEF',
												},
											],
										},
									},
								},
								{
									value: 1.325 - scoresPercentage,
									itemStyle: {
										opacity: 0,
										color: 'rgba(255, 255, 255, 0)',
									},
								},
							],
						},
						{
							type: 'pie',
							radius: ['87%', '88%'],
							center: ['50%', '55%'],
							zlevel: 10,
							silent: true,
							startAngle: 225,
							endAngle: 45,
							data: [{
									name: '',
									value: scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(0,0,0,0)',
									},
								},
								{
									name: '',
									value: 0,
									label: {
										position: 'inside',
										backgroundColor: '#00FFF2',
										borderRadius: 12,
										padding: 3,
										borderWidth: 3,
										borderColor: 'rgba(0,255,239,0.8)',
									},
								},
								{
									name: '',
									value: 1.325 - scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(255,255,255,0)',
									},
								},
							],
						},
					]
				};

				_this.radarchart3.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart3.resize();
				});

			},

			onHealthTarget: function(nameecharts, seriesName) {
				let _this = this;
				_this.tempchart = this.$echarts.init(document.getElementById(nameecharts));
				var xdata = [];
				var dataArr = [];
				for (var i = 1; i < 30; i++) {
					xdata.push(i);
					dataArr.push(Math.floor(Math.random() * 80 + 5))
				}
				var max = Math.max.apply(null, dataArr);

				let option = {
					title: {
						text: seriesName,
						left: 'center',
						top: '5%',
						textStyle: {
							color: '#ffffff'
						}
					},
					tooltip: {
						show: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {

						}
					},
					grid: {
						left: "10%",
						bottom: "10%",
						top: "20%",
						containLabel: true
					},
					xAxis: {
						type: "category",
						data: xdata,
						axisLabel: {
							show: true,
							color: "#fff",
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');

							}
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2
							}
						}
					},
					yAxis: [{
						type: 'value',
						max: 100,
						axisLabel: {
							formatter: '{value}',
							color: '#fff',
							fontSize: 0.5 * this.ww
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2
							}
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false
						},
						scale: true,
					}],
					series: [{
						name: seriesName,
						type: 'line',
						symbol: 'none',
						smooth: false,
						symbol: "circle",
						markArea: {
							itemStyle: {
								color: 'rgba(158, 221, 255, 0.3)'
							},
							data: [
								[{
										yAxis: '100'
									},
									{
										yAxis: '60'
									}
								]
							]
						},
						markLine: {
							symbol: 'none',
							label: {
								color: 'rgba(255, 255, 255, 0.6)'
							},
							data: [{
								silent: false,
								lineStyle: {
									type: 'dashed',
									color: 'rgba(255,205,60,0.4)',
								},
								yAxis: '60'
							}]
						},
						itemStyle: {
							color: '#34a39a',
							lineStyle: {
								color: "#34a39a",
								width: 2
							},
							areaStyle: {
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#08808b"
									},
									{
										offset: 1,
										color: 'rgba(0,0,0,0.2)',
									}
								])

							}
						},
						data: dataArr
					}, ]
				};

				_this.tempchart.setOption(option, true)
				window.addEventListener("resize", function() {
					_this.tempchart.resize();
				});
			},

			onClearable: function(formName) {
				this.$refs[formName].resetFields();
			},
			random: function(min, max) {
				return Math.floor(Math.random() * (max - min)) + min;
			},
		
		}

	}
</script>

<style lang="scss" scoped>
	.test {
		.contdiv {
			width: 100%;
			height: 300px;
			border: 1px solid #007297 !important;
			margin-bottom: 20px;

			table {
				width: calc(100% - 20px);
				height: calc(100% - 55px);
				border: 1px solid rgba(0, 114, 151, 0.5);
				margin-left: 10px;

				tr td {
					border: 1px solid rgba(0, 114, 151, 0.5);
					width: 10%;
					height: 10%;
					color: #909399;
					font-size: 12px;
					text-align: center;

				}


			}
		}

		.el-divider {
			background-color: rgba(0, 114, 151, 0.5);
			margin-bottom: 40px;

			.el-divider__text {
				background-color: #121C2B;
				color: white;
				font-size: 1.2rem;
				font-family: 'fangsong';
			}
		}

		#echart8,
		#echart9,
		#echart10 {
			ul {
				color: white;
				margin: 0px;
				padding: 0px;
				text-align: center;
				margin: 10px;

				li:nth-child(1) {
					border-image: linear-gradient(to right, #0bc4e9, #007297) 1 10 !important;
					border: 1px solid red;
				}

				li {
					display: inline-block;
					width: 25%;

					span {
						width: 10px;
						height: 10px;
						margin-right: 10px;
						background-color: #A7D691;
						display: inline-block;
						vertical-align: middle;
					}
				}
			}

			.str0 {
				background-color: #A7D691;
			}

			.str1 {
				background-color: #FBD379;
			}

			.str2 {
				background-color: #FC9C75;
			}

			.str3 {
				background-color: #EE6C6C;
			}
		}

		#echart9,
		#echart10 {

			.str0 {
				background-color: #A7D691;
			}

			.str1 {
				background-color: #FC9C75;
			}

			.str2 {
				background-color: #EE6C6C;
			}
		}

		#echart8 {
			ul li {
				width: 20%;
				font-size: 12px;
			}
		}
	}
</style>